<template>
  <div class='table-con'>
    <el-table
      :data='tableData'
      :border="tableConfig['border']"
      :open-delay='1000'
      :textSize="tableConfig['textSize'] || '12'"
      :height="isSticky ? null: tableConfig['height']"
      :max-height="tableConfig['maxHeight']"
      style="width: 100%"
      :header-cell-style="tableConfig['headerCellStyle'] || {
          background: '#ECEFF6',
          fontSize: '12px',
          fontWeight: '400',
          color: '#4E5969'
        }"
      v-loading="tableConfig['loading']"
      :row-key="tableConfig['rowKey'] || getRowKeys"
      el-loading-text='加载中...'
      :size="tableConfig['size']"
      ref='table'
      @row-click='rowClick'
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      @radio-change="handleRadioChange"
    >
      <!-- 无数据提示 -->
      <div slot='empty' >
        <div class="emptybox">
            <div class="img"><img src="@/assets/positionEmpty.png" alt=""></div>
            <div class="text">{{ tableConfig['loading']? '':tableConfig['empty']}}</div>
        </div>
      </div>
      <!-- <slot slot='empty'>{{ tableConfig['empty']}}</slot> -->
      <!-- 勾选框 -->
      <el-table-column
        v-if="tableConfig['selection'] || tableConfig['radio']"
        :type="tableConfig['selection'] ? 'selection' : 'radio'"
        width="48"
        align="center"
        :fixed="tableConfig['selectionFixed']"
        :selectable="selectDisableRoom"
        :reserve-selection="tableConfig['reserveSelection']"></el-table-column>
      <template v-for="item in tableColumns">
        <!-- 操作列 -->
        <slot v-if='item.slot' :name='item.slot'></slot>
        <el-table-column
          v-else
          :key='item.prop'
          :label='item.label'
          :prop='item.prop'
          :filterable='item.filterable'
          :fixed='item.fixed'
          :min-width="item.minWidth ? item.minWidth : '100'"
          :width="item.width ? item.width : ''"
          :align="item.align ? item.align : 'left'"
          :sortable="item['sortable'] ? item['sortable'] : false"
          :show-overflow-tooltip="item['showTooltip'] ? item['showTooltip'] : false"
          :resizable="item['resizable'] ? item['resizable'] : false"
          show-tooltip-when-overflow
        >
        <template slot-scope="scope">{{ formatterStr(scope.row[item.prop])}}</template>
        </el-table-column>
      </template>
    </el-table>
    <div class="bottomStickyBox">
      <el-pagination
        v-if="tableConfig['needPagination']"
        :class='calculatePaginationClass'
        :layout="paginationConfig['layout']"
        :total="paginationConfig['total']"
        :current-page.sync="paginationConfig['pageNum']"
        :page-size.sync="paginationConfig['pageSize']"
        :page-sizes.sync="paginationConfig['pageSizes']"
        :pager-count="paginationConfig['pagerCount']"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style='margin-top: 16px; padding: 0'></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PublicTable',
  data() {
    return {}
  },
  props: {
    isSticky: {
      type: Boolean,
      default: () => false
    },
    // 表格数据源
    tableData: {
      type: Array,
      default: () => []
    },
    // 表格列
    tableColumns: {
      type: Array,
      default: () => []
    },
    // 表格列过滤器
    filterBindForm: {
      type: Array,
      default: () => []
    },
    // 表格排序数据
    tableSortNameParams: {
      type: Array,
      default: () => []
    },
    // 表格配置
    tableConfig: {
      type: Object,
      default: () => {
        return {
          border: true, // 是否显示纵向边框
          type: '', // 表格列类型
          rowKey: '', // 表格行的 Key
          textSize: '12', // 表格文字大小
          loading: false, // 是否显示加载中
          filter: false, // 是否显示过滤器
          selection: false, // 是否显示勾选框
          selectionFixed: false, // 是否固定勾选框
          reserveSelection: false, // 在多选表格中是否默认选中第一行
          empty: '暂无数据', // 是否显示无数据提示
          needPagination: true, // 是否需要分页器
          headerCellStyle: { // 表头样式
            background: '#ECEFF6',
            fontSize: '12px',
            fontWeight: '400',
            color: '#4E5969'
          },
          size: 'large', // 表格尺寸
          height: null,
          maxHeight: null,
        }
      }
    },
    // 分页配置
    paginationConfig: {
      type: Object,
      default: () => {
        return {
          pos: 'right', // 分页位置
          layout: 'total,prev,pager,next,sizes,jumper', // 组件布局，子组件名用逗号分隔
          pageSize: 10, // 每页显示条数
          pageNum: 1, // 当前页数
          pagerCount: 7, // 页码按钮的数量
          pageSizes: [10, 20, 50, 100], // 每页显示个数选择器的选项设置
          currentPage: 1, // 当前页数
          total: 100 // 总条数
        }
      }
    },
    // checkbox是否禁用传递函数获取回调值
    triggerFunc: {
      type: Function
    }
  },
  computed: {
    // 动态获取分页器位置
    calculatePaginationClass() {
      if (this.paginationConfig['pos'] === 'right') {
        return 'el-table-pagination-right'
      } else if (this.paginationConfig['pos'] === 'left') {
        return 'el-table-pagination-left'
      } else {
        return 'el-table-pagination-center'
      }
    }
  },
  methods: {
    handleRadioChange(row) {
      this.$emit('handleRadioChange', row)
    },
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event)
    },
    // 获取列筛选数据
    getFilter(item) {
      const value = this.filterBindForm.find(v => v['instanceCode'] === item['instanceCode']) || {} // 筛选值
      const field = this.$store.state.screen.fieldList.find(v => v['instanceCode'] === item['instanceCode']) || {} // 数据源
      return { ...field, ...value }
    },
    // 表格列鼠标移入移出事件
    tableColumnsMouseover(item, index) {
      this.$refs.filter[index].style.display = item.filter ? 'block' : 'none'
    },
    // 表格列鼠标移入移出事件
    tableColumnsMouseout(item, index) {
      this.$refs.filter[index].style.display = 'none'
    },
    // 表格列点击事件
    tableColumnsClick(item, index) {
      console.log('item', item, index)
      this.$set(item, 'showFilter', true)
    },
    // 获取表格行的 Key
    getRowKeys(row) {
      return row.id
    },
    // 多选事件
    handleSelectionChange(val) {
      this.$emit('handleSelectChange', val)
    },
    // 排序事件
    handleSortChange(val) {
      this.$emit('handleSortChange', val)
    },
    // 分页事件
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    // 分页事件
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    },
    // 禁用勾选框
    selectDisableRoom(row) {
      if (!this.triggerFunc) {
        return true
      } else {
        let result = true
        this.triggerFunc((value) => {
          result = value
        }, row)
        return result
      }
    },
    // 格式化表格数据
    formatterStr(row) {
      if (row === null || row === undefined || row === '') {
        return '--'
      } else {
        return row
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.emptybox{
  line-height: 20px;
  .img{
    img{
      width: 150px;
    }
  }
  .text{
    color: #86909C;
  }
}
.table-head-item-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table-item-filter-con {
  display: none;
  cursor: pointer;
  position: absolute;
  right: 4px;
  width: 24px;
  text-align: center;
  height: calc(100% + 2px);
  top: 50%;
  transform: translateY(-50%);
  color: #e5e6eb;
  .el-icon-filter {
    cursor: pointer;
    font-size: 16px;
    color: #4E5969;
  }
}
.table-item-filter-con:hover {
  background: #BEDAFF;
}
//::v-deep .el-table__body-wrapper {
//  min-height: 50px!important;
//}
</style>
<style lang='scss'>
.table-con {
  // .el-table .cell {
  //   //height: 50px;
  //   //line-height: 50px;
  // }
  // .custom-value {
  //   display: block !important;
  //   height: 48px;
  //   margin-top: 0;
  //   .el-table-th-title{
  //     display: block;
  //     height: 48px;
  //     margin-top: 0;
  //   }
  // }
}
</style>
